module.exports = __webpack_public_path__ + "static/media/glass.971625aa.svg";